

import React from "react";
import { Link } from "react-router-dom";
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { TbBrandFiverr } from "react-icons/tb";
// import { RiInstagramFill } from "react-icons/ri";


export default function Footer() {

  return (
    <>
      <div className="bg-[#000000] pb-4  text-white px-3 md:px-5 w-full flex flex-col items-center justify-center gap-y-10">
        

        <div className="flex flex-col gap-y-1  lg:items-start lg:flex-row justify-around w-full px-3 pt-5 text-[#eeeeee] gap-x-3">
          <div className="flex flex-col lg:max-w-[40%] border-b lg:border-0 border-[#b0b0b0] py-3 lg:py-0">
            <h1 className="text-2xl font-bold text-white ">Gulfam Haider</h1>
            <p className="mt-3 text-sm md:text-[16px] w-[95%] sm:w-[80%] md:w-[90%] lg:w-[90%]">A Result-Oriented Web Developer building and managing Websites and Web Applications that leads to the success of the overall product</p>
          </div>

          <div className=' items-start gap-y-3 lg:gap-y-2 text-md  flex-col flex  border-b lg:border-0 border-[#b0b0b0] py-3 lg:py-0 '>
            <h6 className="hidden text-2xl font-bold text-white lg:block">Content</h6>
            <h6 className='cursor-pointer text-white font-[900]  text-[20px] tracking-wide lg:font-normal lg:text-[16px]  lg:tracking-normal lg:text-[#bbbbbb] hover:scale-110 transition-all duration-150   mt-1 '><Link to='/' className='no-underline hover:text-white ' title='Home page'> HOME </Link></h6>
            <h6 className='cursor-pointer text-white font-[900] hover:scale-110 transition-all duration-150   text-[20px] tracking-wide lg:font-normal lg:text-[16px] lg:tracking-normal lg:text-[rgb(187,187,187)]  '><Link to='/about-me' className=' hover:text-white' title='About Me page'>ABOUT ME</Link></h6>
            <h6 className='cursor-pointer text-white font-[900] text-[20px] tracking-wide lg:font-normal lg:text-[16px] lg:tracking-normal lg:text-[#bbbbbb] hover:scale-110 transition-all duration-150 '><Link to='/my-projects' className='hover:text-white ' title='My Projects page'>MY PROJECTS</Link></h6>
            <h6 className='cursor-pointer text-white font-[900]  text-[20px] tracking-wide lg:font-normal lg:text-[16px] lg:tracking-normal lg:text-[#bbbbbb] hover:scale-110 transition-all duration-150  '><Link to='/my-team' className='hover:text-white 'title='My Team page'>MY TEAM</Link></h6>
            <h6 className='cursor-pointer text-white font-[900]  text-[20px] tracking-wide lg:font-normal lg:text-[16px] lg:tracking-normal lg:text-[#bbbbbb] hover:scale-110 transition-all duration-150   '><Link to='/contact-me' className='hover:text-white ' title='Contact Me page'> CONTACT ME</Link></h6>

          </div>

          <div className="text-[#f69670]  items-start gap-y-1 text-md  flex-col flex  py-3 pb-5 lg:py-0">
            <h6 className="text-2xl font-bold text-white ">Social</h6>
            <div className="flex items-center mt-1 gap-x-3"> 
            <a href="https://www.linkedin.com/in/gulfam-haider-861016291/" target="_blank" rel="noopener noreferrer" title="LinkedIn Profile"><FaLinkedin size={28}  className="text-white cursor-pointer"/></a>
            <a href="https://github.com/Gulfam619" target="_blank" rel="noopener noreferrer" title="Github Profile"><FaGithub size={26} className="text-white cursor-pointer"/></a>
           <a href="https://www.fiverr.com/gulfam207" target="_blank" rel="noopener noreferrer" title="Fiverr Profile"><TbBrandFiverr  size={28}  className="text-black bg-white rounded-full cursor-pointer"/></a>
            </div>
            
          </div>
        </div>
        <div id="copywrite-text">
        Copyrights © 2024 Reserved. Made by <a href="/">        Gulfam Haider</a>
       </div>

      </div>
    </>
  );
}